import Cookies from "js-cookie";
import React from "react";
import { Link } from "react-router-dom";
import { COOKIES } from "../../../data/enums";
import { ROUTES } from "../../../routing/routes";
import Button from "../button/Button";

declare const $: any;

// -----------------------------------------------------------------
// I n t e r f a c e s
// -----------------------------------------------------------------
interface Props {
  onClose: any;
}

const CookieBar = ({ onClose, ...props }: Props) => {
  // -----------------------------------------------------------------
  // L o c a l   v a r s
  // -----------------------------------------------------------------

  // -----------------------------------------------------------------
  // N a v i g a t i o n   v a r s
  // -----------------------------------------------------------------

  // -----------------------------------------------------------------
  // S t a t e
  // -----------------------------------------------------------------

  // -----------------------------------------------------------------
  // R e f s  (DOM)
  // -----------------------------------------------------------------

  // -----------------------------------------------------------------
  // u s e S e l e c t o r   m e t h o d s  (redux)
  // -----------------------------------------------------------------

  // -----------------------------------------------------------------
  // W o r k i n g   m e t h o d s
  // -----------------------------------------------------------------
  const setCookie = () => {
    // Expire in 5 years
    Cookies.set(COOKIES.COOKIES_ACCEPTED, "true", { path: "", expires: 365 * 5 });

    const timer = 500;
    // Fade out with jquery and then hide with react
    $(".cookie-bar").fadeOut(timer);
    setTimeout(() => {
      onClose();
    }, timer);
  };

  // -----------------------------------------------------------------
  // R e n d e r   m e t h o d s
  // -----------------------------------------------------------------

  // -----------------------------------------------------------------
  // L i f e c y c l e
  // -----------------------------------------------------------------

  // -----------------------------------------------------------------
  // u s e E f f e c t   m e t h o d s
  // -----------------------------------------------------------------

  // -----------------------------------------------------------------
  // T e m p l a t e
  // -----------------------------------------------------------------
  return (
    <div className="cookie-bar">
      <div className="content">
        We and selected partners, use cookies or similar technologies as specified in the{" "}
        <Link to={ROUTES.COOKIE_POLICY}>cookie policy</Link>. With respect to advertising, we and
        selected third parties, may use precise geolocation data and actively scan device
        characteristics for identification in order to store and/or access information on a device
        and process personal data (e.g. browsing data, IP addresses, usage data or unique
        identifiers) for the following purposes: personalised ads and content, ad and content
        measurement, and audience insights; develop and improve products. You can consent to the use
        of such technologies by closing this notice or accepting the policy.
      </div>
      <div className="actions">
        <Link to={ROUTES.COOKIE_POLICY} className="btn btn-primary btn-outline btn-sm">
          Read more
        </Link>
        <Button className="btn btn-primary btn-sm" onClick={setCookie}>
          Accept
        </Button>
      </div>
    </div>
  );
};
export default CookieBar;
